
export const planFeatures = [
  {
    id: "plan-firstock-5paisa",
    title: "Firstock & 5Paisa",
    features: [{
      heading: "Demat Account Opened Under Us:",
      subFeatures: [
      "Demat Account Opened Under Us",
      "Free Terminal",
      "Free Algo Signals",
      "Free Algo (coming soon)",
      "Free BackTest (coming soon)",
      "Deeply Discounted Discover Plan Rates",
      "Multiple Accounts (No Limit)",
      "Unlimited Trades / Algo Runs (No Limit)",
      "Simulation Trading (Forward Testing) purchasable at discounted rates",
      ]
    },
      {
        heading: "Existing 5paisa & Firstock Users:",
        subFeatures: [
          "All features as above for first account only",
          "Deeply Discounted Discover Plan Rates",
          "Simulation Trading (Forward Testing) can be purchased at a deeply discounted rates",
          "Unlimited Trades / Algo Runs on all accounts (free & addon) - No Limit",
        ]
      }
    ],
  },
  {
    id: "plan-manual",
    title: "Terminal",
    features: [
      "Trade Unlimited Strategies Manually",
      "Single Click Multi Leg Strategy Execution",
      "Track Multiple Strategies easily (Unique Feature)",
      "Trade from Strangle, Straddle Chain",
      "Trade Huge Quantities with Auto Slicing",
      "Forward Testing (Simulation Trading)",
      "Real Live Trades in Brokers",
      "Robust Order Management System (OMS)",
      "Robust Risk Management System (RMS) at multiple levels",
      "Simple, Fast and Robust Execution Engine",
      "Low Latency (< 100ms) Execution Engine",
    ],
  },
  {
    id: "plan-signals",
    title: "Algo Signals",
    features: [
      "Trade Unlimited Algo Strategies",
      "Configure any complex multi leg strategies",
      "Dynamic Strike Selection using Price, Moneyness, Distance, Delta, etc",
      "Dynamic Expiry Selection",
      "Integrate Trade Entry/Exit Signals from any external systems",
      "Supports Tradingview, Python, AmiBroker, MT4",
      "Supports signal from any external system",
      "Robust Order Management System (OMS)",
      "Robust Risk Management System (RMS) at multiple levels",
      "Low Latency (< 100ms) Execution Engine",
    ],
  },
  {
    id: "plan-unlimited",
    title: "Unlimited",
    features: [
      "All features in Terminal",
      "All Features in Algo Signals",
      "Clear and Separate Strategy tracking for your Manual and Algo Trades",
      "Priority Access to new features & products",
    ],
  },
];

export default planFeatures;


